<template>
    <div class="editable-restriction-message ivu-message-success" data-testid="editable-restriction-message">
        <span><Icon type="ios-checkmark-circle" /></span>
        <span>
            Your team can now make changes to {{ label }}.
            <a @click="showModal">Tell me more</a>
        </span>
    </div>
</template>

<script lang="ts">
import { h as hVue } from "vue";

import EditableRestrictionMessageContent from "@/components/Campaign/Editables/EditableRestrictionMessageContent.vue";

export default {
    name: "EditableRestrictionMessage",
    props: {
        label: {
            type: String
        },

        roleName: {
            type: String
        }
    },

    methods: {
        showModal() {
            this.$Modal.info({
                render: (h: typeof hVue) =>
                    h(EditableRestrictionMessageContent, {
                        roleName: this.roleName
                    }),
                okText: "Got it"
            });
        }
    }
};
</script>
